import cookie from 'vue-cookies'
import { login, logout, userToDoList } from '@/api/user'

// let info = localStorage.getItem('SET_USERINFO') ? JSON.parse(localStorage.getItem('SET_USERINFO')) : {}
// 解密
let decrypt = function (data) {
  try {
    let result = atob(data)
    let set = decodeURIComponent(result)
    return JSON.parse(set)
  } catch (e) {
    throw Error('解密出错')
  }
}
let info = {}
if (localStorage.getItem('SET_USERINFO')) {
  info = decrypt(localStorage.getItem('SET_USERINFO'))
}
const state = {
  token: cookie.get('token'),
  userInfo: info,
  tipsNumber: null,
  isCollapse: false
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_TIPSNUMBER: (state, tipsNumber) => {
    state.tipsNumber = tipsNumber
  },
  SET_COLLAPSE: (state, isCollapse) => {
    state.isCollapse = isCollapse
  }
}
const actions = {
  // 登录
  login ({ commit }, userInfo) {
    const { userName, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ userName, password }).then(res => {
        const { data } = res
        commit('SET_TOKEN', data.token)
        cookie.set('token', data.token)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //   退出
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout().then(res => {
        commit('SET_TOKEN', '')
        commit('SET_LOADMENU', '')
        commit('SET_COMPANYLIST', '')
        cookie.remove('token')
        // cookie.remove('perms') 由于报错，因此放在登陆页面
        // commit('SET_USERPERMS', {})
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 前端 登出
  FedLogOut ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_LOADMENU', '')
      commit('SET_USERPERMS', '')
      commit('SET_COMPANYLIST', '')
      commit('SET_USERPERMS', {})
      cookie.remove('token')
      cookie.remove('perms')
      resolve()
    })
  },
  // 处理菜单栏代办事项的问题
  GetNeedToTips ({ commit }) {
    return new Promise((resolve, reject) => {
      userToDoList({ page: 1, pageSize: 100 }).then(res => {
        let index = 0
        res.data.rows.forEach(item => {
          if (item.status == 0) {
            index += 1
          }
        })
        commit('SET_TIPSNUMBER', index)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }

}
export default {
  // namespaced: true, // 命名作用域
  state,
  mutations,
  actions
}
